export enum ArticleTypes {
  ACTUAL = 'ACTUAL',
  INFORMATION = 'INFORMATION',
  HIGHLIGHTED = 'HIGHLIGHTED',
  OTHER = 'OTHER',
}
